import { render, staticRenderFns } from "./BowToggle.vue?vue&type=template&id=6d2a7869&"
import script from "./BowToggle.vue?vue&type=script&lang=js&"
export * from "./BowToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports